export default __webpack_public_path__ + "static/media/profile.fa5a7ac2.jpg";